const locale = {
	YES: 'Igen',
	NO: 'Nem',
	CANCEL: 'Mégse',
	LOADING: 'Betöltés...'
};

export default locale;
